import classNames from 'classnames/bind';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Icon } from '@fluentui/react';
import styles from './Tools.module.scss';
const cx = classNames.bind(styles);

const ToolSelector = () => {
    const { t } = useTranslation();

    return (
        <div className={cx('tools-list-container')}>
            <Link
                to={`/tools/data-pusher`}
                style={{ textDecoration: 'none', color: 'inherit' }}
            >
                <div
                    className={cx('tool-link-card')}
                >
                    <h2 className={cx('tools-link-header')}>
                        {t('tools.dataPusher.title')}
                        <Icon iconName="Diagnostic" />
                    </h2>
                    <p>{t('tools.dataPusher.description')}</p>
                </div>
            </Link>
        </div>
    );
};

export default ToolSelector;
